import { Directive, inject, OnInit } from '@angular/core';
import { LazyLoadStyleService } from '../../services/lazy-load-style/lazy-load-style.service';

@Directive({
  selector: '[nscfLazyLoadOwlCarouselStyle]',
  standalone: true,
})
export class LazyLoadOwlCarouselStyleDirective implements OnInit {
  private readonly lazyLoadStyleService = inject(LazyLoadStyleService);

  ngOnInit() {
    this.lazyLoadStyleService.loadOwlCarousel();
  }
}
